module.exports = __webpack_public_path__ + "Roboto-Medium.d08840599e05db734565.ttf";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Roboto-Medium.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Medium.ttf
// module chunks = main